<template>
  <div class="case-wrapper">
    <div class="case-banner customer-banner">
      <div class="case-banner-name wow fadeInDown">标杆客户</div>
      <div class="case-logo" :class="{'case-mb-logo': isMobileStatus}">
        <div class="case-a-wrapper" v-for="(p,pIndex) in 2" :key="pIndex">
          <a v-for="(item,index) in caseLogoList.slice(pIndex * 9, p * 9)" :key="index" :class="'cus-a' + (index + 1 + pIndex * 9)" class="wow bounceIn" :data-wow-delay="`${item.delay}s`">
            <img class="cus-bg" src="static/images/case/logo-bg.png" />
            <img class="cus-logo" v-if="item.logoSrc" :src="item.logoSrc" alt="暂无">
            <span class="cus-text" v-else-if="item.name">{{ item.name }}</span>
            <div class="cus-write" v-else>
              <i class="icon el-icon-plus"></i>
              <p>为您留位</p>
            </div>
          </a>
        </div>
      </div>
      <div class="banner-nav" v-if="isPcStatus">
        <a v-for="(item,index) in navList" :key="index" :class="{'active': currentNav === index + 1}" @mouseenter="currentNav = index + 1">{{ item.name }}</a>
      </div>
    </div>
    <template v-if="isPcStatus">
      <nav-item v-if="currentNav" :navIndex="currentNav"></nav-item>
    </template>
    <div class="list-wrapper" v-else>
      <ul>
        <li v-for="(item,index) in navList" :key="index" :class="{'active': currentNav === index + 1}" @click="handleCurrentNav(item,index)">
          <a>{{ item.name }}<i :class="[currentNav === index + 1 && showNavVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i></a>
          <nav-item v-if="currentNav === index + 1 && showNavVisible" :navIndex="currentNav"></nav-item>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import customData from './data';
import navItem from './navItem.vue';
import { mapState } from 'vuex';
export default {
  components: { navItem },
  data() {
    return {
      ...customData,
      currentNav: 1,
      showNavVisible: true
    }
  },
  computed: {
    ...mapState({
      clientWidth: state => state.clientWidth,
      isMobile: state => state.isMobile,
    }),
    isPcStatus() {
      return this.clientWidth > 1044 && !this.isMobile;
    },
    isMobileStatus() {
      return this.clientWidth <= 750  && this.isMobile;
    }
  },
  methods: {
    handleCurrentNav(item,index) {
      let targetIndex = index + 1;
      this.showNavVisible = this.currentNav === targetIndex ? !this.showNavVisible : true;
      this.currentNav = targetIndex;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/case.scss';
</style>



// WEBPACK FOOTER //
// src/components/case/case.vue